import { supabase } from "@/integrations/supabase/client";

/** Returns headers with the current session's access token. */
export async function authHeaders(extra?: Record<string, string>) {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.access_token) {
    throw new Error("No active session. Please sign in again.");
  }
  return {
    Authorization: `Bearer ${session.access_token}`,
    "Content-Type": "application/json",
    ...(extra ?? {}),
  };
}

/** Fetch wrapper that injects Authorization automatically. */
export async function authFetch(input: string | URL | Request, init: RequestInit = {}) {
  const headers = await authHeaders(init.headers as Record<string, string> | undefined);
  try {
    const res = await fetch(input, { 
      ...init, 
      headers, 
      mode: 'cors',
      credentials: "omit" 
    });
    if (!res.ok) {
      const text = await res.text().catch(() => "");
      throw new Error(text || `Request failed with ${res.status}`);
    }
    return res;
  } catch (error: any) {
    console.error('authFetch error:', {
      url: typeof input === 'string' ? input : input instanceof URL ? input.toString() : 'Request object',
      error: error.message,
      name: error.name,
      stack: error.stack
    });
    throw error;
  }
}
